"use client";
import type {
    Breadcrumb,
    ChildContainerProps,
    LayoutConfig,
    LayoutContextProps,
    LayoutState,
} from "../../types";
import React, { useState } from "react";

export const LayoutContext = React.createContext({} as LayoutContextProps);

export const LayoutProvider = (props: ChildContainerProps) => {
    const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);
    const [layoutConfig, setLayoutConfig] = useState<LayoutConfig>({
        ripple: false,
        inputStyle: "outlined",
        menuMode: "drawer",
        menuTheme: "colorScheme",
        colorScheme: "light",
        theme: "green",
        scale: 13,
    });

    const [layoutState, setLayoutState] = useState<LayoutState>({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        overlaySubmenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        resetMenu: false,
        sidebarActive: false,
        anchored: false,
    });

    const onMenuToggle = () => {
        if (isOverlay()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                overlayMenuActive: !prevLayoutState.overlayMenuActive,
            }));
        }

        if (isDesktop()) {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuDesktopInactive:
                    !prevLayoutState.staticMenuDesktopInactive,
            }));
        } else {
            setLayoutState((prevLayoutState) => ({
                ...prevLayoutState,
                staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive,
            }));
        }
    };

    const showConfigSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            configSidebarVisible: true,
        }));
    };

    const showProfileSidebar = () => {
        setLayoutState((prevLayoutState) => ({
            ...prevLayoutState,
            profileSidebarVisible: !prevLayoutState.profileSidebarVisible,
        }));
    };

    const isOverlay = () => {
        return layoutConfig.menuMode === "overlay";
    };

    const isSlim = () => {
        return layoutConfig.menuMode === "slim";
    };

    const isSlimPlus = () => {
        return layoutConfig.menuMode === "slim-plus";
    };

    const isHorizontal = () => {
        return layoutConfig.menuMode === "horizontal";
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    // const localToken ='eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMTY5MCIsInVzZXJuYW1lIjoic2Vsb3BpYUBhZG1pbi5jb20iLCJyb2xlcyI6WyIxIl0sImlhdCI6MTc3MTA1ODU4MywiZXhwIjoxODAyMTYyNTgzLCJqdGkiOiI0YWQ4YmZkZC1lMTk5LTRiNjQtOTYwMi1iYjcyYjc3NjVjODEifQ.EZ-xAQWo_WRyS6_oHAUGM-mI2C4GPT1it6VWAQwCC_FjJ3oH9-ZyMQKTm05EyyXqBYw1wP6_FOvL-P4svJpGQRHiaaYdtL0K5IhvQWJ-3XfkXDi4gmSX2e_HxNeHIGoYYJmgiy1fsqIw3acMaFFSqqkRf73WEjWa_G0YmDQ5VZlTHuSfV1HAaXWpm-qrykV5eAh8cCOQWy7tBHFRaLs3OcaCd-8wBCkqB7dQT79dIbyM_79w_z8mtb_kfp4_2nL2v0p7TAZ6zuElLPDC-LcU24sc4bXCxevX1Pio6e-yVNgQTib6SIk70bKL688Tb11EuN8uMRWenCDkUoOlTO3GJw'

    const [accessToken, setAccessToken] = useState<string>('')
    const [routePermissions,setRoutePermissions] = useState({});

    const value = {
        layoutConfig,
        setLayoutConfig,
        layoutState,
        setLayoutState,
        onMenuToggle,
        showConfigSidebar,
        showProfileSidebar,
        isSlim,
        isSlimPlus,
        isHorizontal,
        isDesktop,
        breadcrumbs,
        setBreadcrumbs,
        accessToken,
        setAccessToken,
        routePermissions,
        setRoutePermissions
    };

    return (
        <LayoutContext.Provider value={value}>
            <>
                {props.children}
            </>
        </LayoutContext.Provider>
    );
};
